const AUTHORIZATION_LEVEL = {
    ADMIN: 0b1,
    STORE_ADMIN: 0b10,
    STORE_MGR: 0b100,
    INVENTORY_MGR: 0b1000,
    SALES: 0b10000,
    CUSTOMER: 0b100000000000
};
export default AUTHORIZATION_LEVEL;